import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { AccountApiService } from '../../../../services/account.api.service';
import { AlertifyService } from '../../../../services/alertify.service';

@Component({
  templateUrl: './event.subscription.tiers.modal.component.html',
  styleUrls: ['./event.subscription.tiers.modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class EventSubscriptionTiersModalComponent implements OnInit {
  public tiers: any[] = [];
  public loading = false;
  public savingId = '';
  public newTier: any = { name: '', annualEventLimit: null, isActive: true };

  constructor(
    private accountApiService: AccountApiService,
    private alertify: AlertifyService,
    private dialogRef: MatDialogRef<EventSubscriptionTiersModalComponent>,
  ) {}

  public ngOnInit() { this.load(); }

  public load() {
    this.loading = true;
    this.accountApiService.getEventSubscriptionTiers()
      .finally(() => this.loading = false)
      .subscribe((tiers) => this.tiers = tiers || []);
  }

  public create() {
    if (!this.isValid(this.newTier)) return;
    this.savingId = 'new';
    this.accountApiService.createEventSubscriptionTier(this.newTier)
      .finally(() => this.savingId = '')
      .subscribe(() => {
        this.newTier = { name: '', annualEventLimit: null, isActive: true };
        this.alertify.successfully('Subscription tier created.');
        this.load();
      });
  }

  public save(tier: any) {
    if (!this.isValid(tier)) return;
    this.savingId = tier._id;
    this.accountApiService.updateEventSubscriptionTier(tier._id, tier)
      .finally(() => this.savingId = '')
      .subscribe(() => this.alertify.successfully('Subscription tier updated.'));
  }

  public close() { this.dialogRef.close(); }

  private isValid(tier: any) {
    if (!tier.name || !Number.isInteger(Number(tier.annualEventLimit)) || Number(tier.annualEventLimit) < 1) {
      this.alertify.error('Enter a tier name and a positive whole-number annual limit.');
      return false;
    }
    tier.annualEventLimit = Number(tier.annualEventLimit);
    return true;
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/admin/accounts/event.subscription.tiers/event.subscription.tiers.modal.component.ts